export default __webpack_public_path__ + "static/media/backgroundLogoXbank.c1727d56.svg";